/** Single org channel for notifications and automation job updates. */
export const getOrganizationChannelName = (organizationId: string) =>
  `organization:${organizationId}`;
